<template>
  <div class="container">
    <div class="header">
      <navBar></navBar>
    </div>
    <div class="main-wrapper">
      <div class="card">
        <el-menu class="el-menu" router :default-active="$route.path">
          <myitem :dataList="routes"></myitem>
        </el-menu>
      </div>
      <div class="main">
        <router-view :key="$route.path"> </router-view>
      </div>
    </div>
  </div>
</template>

<script>
import myitem from "./menuItem/index.vue";
import routerList from "@/router/logistics/pc";
import navBar from "./headerLogo/index.vue";
// import api from "@/apis/medal";
export default {
  name: "gzhpc",
  components: {
    myitem,
    navBar
  },
  data() {
    return {
      routerData: []
    };
  },
  computed: {
    // 通过路由列表
    routes() {
      return routerList;
    }
  },
  created() {
    this.queryData();
  },
  mounted() {
    console.log(this.routes,'routes111');
    console.log(this.$route,'$route222');
    
    
  },
  methods: {
    queryData() {
      // api
      //   .queryMedalUserPermission({ name: this.$store.state.userInfo.username })
      //   .then(res => {
      //     if (res.code == 200) {
      //       this.routerData = this.filterData(
      //         routerList[0].children,
      //         res.data.list
      //       );
      //     }
      //   });
    },
    // filterData(data, dataList) {
    //   const list = data?.filter(item => {
    //     if (item.path == "/medal/badgeManage") {
    //       if (dataList.length > 0 && dataList[0]?.administrators) {
    //         item.show = true;
    //       } else {
    //         if (dataList[0]?.medalRecord) {
    //           item.show = true;
    //         } else {
    //           item.show = false;
    //         }
    //       }
    //     } else {
    //       item.show = true;
    //     }
    //     item.children = this.filterData(item.children);

    //     return item;
    //   });
    //   return list;
    // }
  }
};
</script>

<style lang="scss">
.container {
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  .header {
    padding: 0;
    // height: 112px;
    background: #fff;
  }
  .main-wrapper {
    flex: 1;
    display: flex;
    .card {
      width: 13vw;
      // border: 1px solid #fff;
      background-color: #fff;
      overflow: hidden;
      color: #303133;
      // box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
    }
    .el-menu {
      border: 0;
      width: 13vw;
      color: #fff;
      background-color: #fff; 
      margin-top: 40px;
      height: 100%;
      overflow-y: auto;
      &::-webkit-scrollbar {
        display: none;
      }
      .el-menu-item {
        color: #666;
        text-align: left;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding-left: 20px;
      }
      .el-submenu__title {
        text-align: left;
      }
      .el-menu-item.is-active {
        // background-color: #00ada7;
        i {
          color: #4FA27D;
        }

        span {
          color: #4FA27D;
          font-weight: 900;
        }
      }
      //设置选鼠标指针浮动在一级菜单的设置
      .el-menu-item:hover {
        background-color: #fff !important;
      }
      span {
        font-size: 29px;
        white-space: normal;
        word-break: break-all;
        line-height: 30px;
        // flex: 1;
      }
    }
    .main {
      width: 87vw;
      background: #FAFAFA;
      padding: 82px;
    }
  }
}
</style>
